<template>
  <div class="message-book">
    <input type="text" :value="value" @input="onInput" ref="input"> <slot> <div class="btn" @click="btn"> {{ text }} </div> </slot>
  </div>
</template>

<script>
  export default {
    name: 'message-book',
    props: {
      text: {
        type: String,
        default: '按钮'
      },
      value: {
        type: String,
        default: ''
      },
      showfocus: {
        type: Boolean,
        default: true,
      }
    },
    methods: {
      onInput(e) {
        this.$emit('input', e.target.value)
      },
      btn() {
        this.$emit('btn');
      }
    },
    watch: {
      showfocus: {
        handler() {
          this.$refs.input.focus();
        },
        deep: true
      },
    }
  }
</script>

<style scoped>
  .message-book {
    padding: 0.2rem;
    background-color: white;
    width: 100%;
    display: flex;
  }
    .message-book input {
      flex: 1;
      padding: 0.1rem 0.2rem;
      border-radius: 0.1rem;
      background-color: #f0eef3;
    }
    .btn {
      width: 1rem;
      text-align: center;
      height: 100%;
      padding: 0.2rem;
      margin-left: 0.2rem;
      border-radius: 0.1rem;
      background-color: rgb(202, 169, 233);
      color: white;
      display: flex;
      align-items: center;
    }
</style>